import React from 'react';
import styled from 'styled-components';
import Loading from 'components/Loading';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(p) => (p.$transparent ? 'transparent' : 'rgba(0, 0, 0, 0.35)')};
  z-index: 9999;
`;

const FullScreenLoader = ({ transparent = false, size = 48, isLoading = false }) => {
  return (
    isLoading ? (
      <Overlay $transparent={transparent}>
        <Loading size={size} />
      </Overlay>
    ) : null
  );
};

export default FullScreenLoader;
